import size from 'lodash/size';
export const _size = size;
